import { Asset } from 'contentful';

export interface IGenericTurfappContent {
  image: Asset;
}

export enum ContentTypes {
  GenericTurfappContent = 'genericTurfappContent',
}
